module.exports = __webpack_public_path__ + "static/media/amex.02d48c0a.svg";